/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'score': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M814.748 6.678H209.252C97.948 6.678 6.678 97.948 6.678 209.252v605.496c0 111.304 91.27 202.574 202.574 202.574h605.496c111.304 0 202.574-91.27 202.574-202.574V209.252c0-111.304-91.27-202.574-202.574-202.574zm122.435 808.07c0 66.782-53.426 120.209-120.21 120.209h-607.72c-66.783 0-120.21-53.427-120.21-120.21V209.253c0-66.782 53.427-120.209 120.21-120.209h605.495c66.782 0 120.209 53.427 120.209 120.21v605.495z"/><path pid="1" d="M300.522 325.009c-22.261 0-40.07 17.808-40.07 40.07v427.408c0 22.26 17.809 40.07 40.07 40.07s40.07-17.81 40.07-40.07V365.078c0-22.26-17.81-40.07-40.07-40.07zM512 189.217c-22.26 0-40.07 17.81-40.07 40.07v563.2c0 22.26 17.81 40.07 40.07 40.07s40.07-17.81 40.07-40.07V231.513c0-22.26-17.81-42.296-40.07-42.296zM723.478 449.67c-22.26 0-40.07 17.808-40.07 40.07v302.747c0 22.26 17.81 40.07 40.07 40.07 22.261 0 40.07-17.81 40.07-40.07V489.739c0-22.26-17.809-40.07-40.07-40.07z"/>'
  }
})
